import gql from "graphql-tag";
import { useTesQuery } from "./useTesQuery";

const GET_TAKEBACK_DETAIL = gql`
  query GetTakebackDetail($id: String!) {
    takeback(id: $id) {
      id
      created_at
      updated_at
      customer_id
      quantity
      data
      type_name
      customer_id_belongsTo {
        id
        name
        last_name
        email
        address_line1
        address_line2
        city
        state
        postal_code
        country
      }
      payments_list {
        id
        created_at
        updated_at
        type
        payments_metadata_list {
          key
          value
        }
      }
      takeback_processing_history_list {
        id
        status
        parent_status
        processed_at
        updated_at
        eventId
      }
    }
  }
`;

export const useGetTakebackDetail = (takebackId, options = {}) => {
  return useTesQuery(
    GET_TAKEBACK_DETAIL,
    { id: takebackId },
    {
      enabled: Boolean(takebackId),
      ...options,
    }
  );
};
